export default __webpack_public_path__ + "static/media/blog03.0d6bcbd8.jpg";